import groq from 'groq';

export const PRESS_QUOTES = groq`
  isLinkVisible,
  isQuoteVisible,
  "quotes": pressQuotes->.quotes[] {
    link,
    quote,
    "logo": {
      "alt": logo.alt,
      "url": logo.asset -> url,
      "height": logo.asset -> metadata.dimensions.height,
      "width": logo.asset -> metadata.dimensions.width,
    },
  }
`;

export const PRESS_QUOTES_BLOCK = groq`
  _type == 'pressQuotes' => {
    ${PRESS_QUOTES}
  }
`;
